import { render, staticRenderFns } from "./ChangeMailReception.vue?vue&type=template&id=83b574fc&lang=pug"
import script from "./ChangeMailReception.vue?vue&type=script&lang=js"
export * from "./ChangeMailReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports